import React, { useState } from "react";
import { X } from "lucide-react";
import Marquee from "../components/Marquee";
import { realisations } from "../mock/mock";

const Realisations = () => {
  const [active, setActive] = useState(null);

  return (
    <div>
      <section className="bg-[#FFF6F9] py-16 lg:py-20">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 text-center">
          <span className="font-body text-xs tracking-[0.35em] uppercase text-[#9D184C]">Rim Patisse</span>
          <h1 className="font-title text-4xl md:text-6xl text-[#3A2A30] mt-4">Mes réalisations</h1>
          <p className="font-body text-[#3A2A30]/70 mt-4 max-w-xl mx-auto">
            Un aperçu de mes créations sur mesure, imaginées pour toutes vos occasions.
          </p>
          <div className="w-16 h-[3px] bg-[#9D184C] rounded-full mx-auto mt-6" />
        </div>
      </section>

      <Marquee />

      <section className="max-w-7xl mx-auto px-5 lg:px-8 py-16 lg:py-24">
        <div className="columns-1 sm:columns-2 lg:columns-3 gap-6 [column-fill:_balance]">
          {realisations.map((r, i) => (
            <button
              key={r.id}
              onClick={() => setActive(r)}
              className="card-hover group relative mb-6 w-full block rounded-2xl overflow-hidden border border-[#F3D9E2] shadow-[0_8px_30px_rgba(157,24,76,0.08)] hover:shadow-[0_16px_40px_rgba(157,24,76,0.16)] transition-shadow duration-300 fade-up"
              style={{ animationDelay: `${i * 90}ms` }}
            >
              <img src={r.image} alt={r.title} loading="lazy" className="card-img w-full h-auto object-cover" />
            </button>
          ))}
        </div>
      </section>

      {/* Lightbox */}
      {active ? (
        <div
          className="fixed inset-0 z-[60] bg-black/80 flex items-center justify-center p-4"
          onClick={() => setActive(null)}
        >
          <button
            aria-label="Fermer"
            onClick={() => setActive(null)}
            className="absolute top-5 right-5 text-white/90 hover:text-white"
          >
            <X size={30} />
          </button>
          <div className="max-w-4xl w-full" onClick={(e) => e.stopPropagation()}>
            <img src={active.image} alt={active.title} className="w-full max-h-[85vh] object-contain rounded-xl" />
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default Realisations;
